import React, { useState, useEffect } from "react";
import Select from "react-select";
import { axios, axiosAuth } from "../../helpers";
import { loginData } from "../../stores/auth";
import { useSelector } from "react-redux";

const SelectOption = ({
    url,
    to,
    index = 0,
    placeholder,
    selectedOption,
    handleChangeSelectOption,
    isMulti = false,
    isDisabled = false,
    required = true,
}) => {
    const [options, setOptions] = useState([]); // Options for the dropdown
    const [search, setSearch] = useState(""); // Search term
    const [page, setPage] = useState(1); // Current page for lazy loading
    const [hasMore, setHasMore] = useState(true); // To determine if more data exists
    const [loading, setLoading] = useState(false); // Loading state
    const dataLogin = useSelector(loginData)
    // const [selectedOption, setSelectedOption] = useState(null); // Selected option

    const fetchOptions = async (searchTerm = "", pageNumber = 1) => {
        if (!hasMore && pageNumber !== 1) return; // If no more data, skip further requests
        setLoading(true);
        try {

            const response = await axiosAuth.get(`${url}`, {
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                },
                params: {
                    search: searchTerm,
                    page: pageNumber,
                    limit: 10,
                },
            });

            const newOptions = response.data.data.rows.map((item) => ({
                value: item.id,
                nip: item.nip ?? "",
                roles: item.list_role ?? [],
                label: item.nama,
                index: index,
                key: to,
            }));
            setOptions((prev) =>
                pageNumber === 1 ? newOptions : [...prev, ...newOptions]
            );

            setHasMore(response.data.data.rows.length === 10);
        } catch (error) {
            console.error("Failed to fetch options:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (value) => {
        setSearch(value);
        setPage(1); // Reset to the first page when search changes
        fetchOptions(value, 1);
    };

    const handleMenuScrollToBottom = () => {
        console.log("handleMenuScrollToBottom");

        if (!loading) {
            const nextPage = page + 1;
            setPage(nextPage);
            fetchOptions(search, nextPage);
        }
    };

    useEffect(() => {
        fetchOptions(); // Initial load
    }, []);

    return (
        <>
            <Select
                isMulti={isMulti}
                name={to}
                id={to}
                options={options}
                value={selectedOption}
                onChange={handleChangeSelectOption}
                onInputChange={handleInputChange}
                onMenuScrollToBottom={handleMenuScrollToBottom}
                isLoading={loading}
                placeholder={placeholder}
                required={required}
                isClearable={false}
                isDisabled={isDisabled}
            />
        </>

    );
};

export default SelectOption;
